import { IForm } from "../../../form-modal/form-modal.types";
import { TextInput } from "../../../form-modal/inputs/text-input/text-input.component";

export const DuplicateCampaignBriefForm = (props: IForm) => {
  return <TextInput form={props.form} label="Campaign Brief Name" name="name" required />;
};
